// extracted by mini-css-extract-plugin
export default {"container":"msp-report_container__qLI6Q"};